module.exports = __webpack_public_path__ + "img/GAME_SOCCER2.c78eba8b.jpg";